import React, { forwardRef, useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { ThreeDot } from "react-loading-indicators";
import i18n from "../../lib/i18n";

const AdsDetailsPop = forwardRef(({ data, onClose }, ref) => {
  
  const allPhotos = [data?.main_photo, ...data?.photos?.map((e) => e.photo ) ?? []].filter(Boolean);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingPhoto, setLoadingPhoto] = useState(true);
  const t = i18n.t.bind(i18n); 

  const nextSlide = () => {
    const nextIndex = (currentIndex + 1) % allPhotos.length;
    setLoadingPhoto(true);
    setCurrentIndex(nextIndex);
  };

  const prevSlide = () => {
    const prevIndex = currentIndex === 0 ? allPhotos.length - 1 : currentIndex - 1;
    setLoadingPhoto(true);
    setCurrentIndex(prevIndex);
  };

  useEffect(() => {
    if (data && Object.keys(data || {}).length > 0) {
      setLoading(false);
      // reset index if needed when new data arrives
      setCurrentIndex(0);
    }
  }, [data]);

    const handleImageLoad = () => {
    setLoadingPhoto(false);
  };

  const hasMultiplePhotos = allPhotos.length > 1;

  const isEmpty = !data || Object.keys(data || {}).length === 0;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50" >
      <div className="bg-thirdly rounded-2xl shadow-lg lg:w-[40%] md:w-[60%] sm:w-[70%] xs:w-[50%] max-w-4xl p-6 relative overflow-y-auto max-h-[86vh] scrollable" ref={ref}>

        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-500 hover:text-red-500 text-xl"
        >
          ✕
        </button>

        {loading && (
          <div className="flex items-center justify-center h-96 w-full">
            <ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" />
          </div>
        )}

        {!loading && !isEmpty && (
          <>
            <h2 className="text-2xl flex-1 text-center text-white font-bold mb-1">
              {data?.title}
            </h2>

            <div className="relative flex justify-center items-center w-full h-64 sm:h-80 mb-1">
              {loadingPhoto && (
                <div className="absolute z-10 bg-black/60 text-white px-4 py-2 rounded">
                  Loading...
                </div>
              )}
              <img
                key={currentIndex} 
                src={allPhotos[currentIndex]}
                alt="Ad"
                onLoad={handleImageLoad}
                className="w-[500px] h-[300px] object-cover rounded-xl"
              />
              {hasMultiplePhotos && (<>
              <button
                onClick={prevSlide}
                className="absolute top-1/2 -translate-y-1/2 left-1 bg-secondary p-1 rounded-full text-white"
              >
                <IoIosArrowBack size={20} />
              </button>

              <button
                onClick={nextSlide}
                className="absolute top-1/2 -translate-y-1/2 right-1 bg-secondary p-1 rounded-full text-white"
              >
                <IoIosArrowForward size={20} />
              </button>
              </>)}
            </div>

            <div className="space-y-2 text-white">
              <h3 className="text-lg font-semibold mb-2">{t("order.ads_information")}</h3>
              <div className="ms-2 flex flex-col justify-start items-start gap-2">
                <p>
                  <span className="font-semibold">{t("order.description")} : </span>
                  {data?.description}
                </p>
                <p>
                  <span className="font-semibold">{t("order.order_status")} : </span>
                  <span
                    className={`px-2 py-1 rounded text-sm ${
                      data?.order == "CONFIRM"
                      ? "bg-green-600 text-white"
                      : data?.order == "SoldRemoved"
                      ? "bg-blue-600 text-white"
                      : data?.order == "REJECT"
                      ? "bg-red-500 text-white"
                      : "bg-red-100 text-black"
                    }`}
                  >
                    {data?.order}
                  </span>
                </p>
                <p>
                  <span className="font-semibold">{t("order.category_name")} : </span>
                  {data?.category_name}
                </p>
                <p>
                  <span className="font-semibold">{t("order.sub_category_name")} : </span>
                  {data?.sub_category_name}
                </p>
                <p>
                  <span className="font-semibold">{t("order.price")} :</span> {data?.price}
                </p>
                <p>
                  <span className="font-semibold">{t("order.address")} :</span> {data?.address}
                </p>
                <p>
                  <span className="font-semibold">{t("order.created_at")} : </span>
                  {data?.publish_at}
                </p>
              </div>
            </div>

            <div className=" space-y-2 text-white mt-3 border-t pt-3">
              <h3 className="text-lg font-semibold mb-2">{t("order.user_information")}</h3>
              <div className="ms-2 flex flex-col justify-start items-start gap-2">
                <p>
                  <span className="font-semibold">{t("order.full_name")} : </span>
                  {data?.publisher_details?.full_name || "undefined"}
                </p>
                <p>
                  <span className="font-semibold">{t("order.username")} : </span>
                  {data?.publisher_details?.user_name || "undefined"}
                </p>
                <p>
                  <span className="font-semibold">{t("order.phone_number")} : </span>
                  {data?.publisher_details?.phone_number || "undefined"}
                </p>
                <p>
                  <span className="font-semibold">{t("order.email")} : </span>
                  {data?.publisher_details?.email || "undefined"}
                </p>
                <p>
                  <span className="font-semibold">{t("order.type")} : </span>
                  {data?.publisher_details?.type || "undefined"}
                </p>
                <p>
                  <span className="font-semibold">{t("order.address")} : </span>
                  {data?.publisher_details?.address || "undefined"} 
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
});

export default AdsDetailsPop;